import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import ChargeFactory from "../../Entity/Factories/ChargeFactory";

export default function* chargeSettle(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_SETTLE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_CHARGE_SETTLE_REQUEST
    });

    let payload: any = {};

    if (!!action.payload?.existedChargeId) {
      payload.existedChargeId =  action.payload?.existedChargeId;
    }

    if (!!action.payload?.newCharge) {
      payload.newCharge = {...action.payload?.newCharge};
    }

    const res = yield call(Http.post, `charge/${action.payload?.id}/settle`, {
      ...payload
    });

    const charge: ChargeInterface = ChargeFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_CHARGE_SETTLE_SUCCESS
    })

    yield put({
      type: Constants.GLOBAL_CHARGE_UPDATE_SUCCESS,
      payload: {
        charge
      }
    })

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, charge);
    }

  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_SETTLE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeSettle() {
  yield takeEvery(Constants.GLOBAL_CHARGE_SETTLE_START, chargeSettle);
}
